module.exports = __webpack_public_path__ + "static/media/about.080d7ce0.jpg";